<div class="control">
  <div class="control__input">
    @if (label()) {
      <label class="control__label">
        {{ label() }}

        @if (isRequired()) {
          <span class="control__required">*</span>
        }
      </label>
    }

    <ng-content />
  </div>

  <ui-error class="control__error" [error]="error()" />
</div>
